import { getLogger } from '@jitsi/logger';

import { JitsiRecordingConstants } from '../../react/features/base/lib-jitsi-meet';
import { getActiveSession } from '../../react/features/recording/functions';
import Settings from '../settings/Settings';


const logger = getLogger(__filename);

/* eslint-disable arrow-body-style*/
export default class Recording {
    /**
     * Start the recording
     */
    start = () => {
        const store = APP.store.getState();
        const session = getActiveSession(store, JitsiRecordingConstants.mode.FILE);

        if (session !== undefined) {
            // recording already running. Do nothing.
            return;
        }

        const { roomSubject } = APP.wildix.methods.getRoomData();
        const { roomToken, websocketUser, baseUrl, pbxSerial = null, xBeesUserId = '' } = store['features/base/config'];
        const appData = JSON.stringify({
            'file_recording_metadata': {
                'share': true,
                'room': roomToken,
                'username': websocketUser,
                xBeesUserId,
                'localDate': Settings.getLocalDate(),
                'baseUrl': baseUrl,
                pbxSerial,
                roomSubject
            }
        });

        logger.log(`Recording is going to start with appData: ${appData}`);

        APP.conference.__getJitsiConference().startRecording({
            mode: JitsiRecordingConstants.mode.FILE,
            appData
        })
            .then(data => {
                APP.WildixAPI.Recording.updateStatusQueue(data._sessionID, 'record', 'on');
            });
    };
}
